import { Injectable, signal, computed } from "@angular/core";
import { ItemFormat } from "./models/itemFormat.model";
import { HttpClient } from '@angular/common/http';
import { DirectSessionLogicService } from './direct-session-logic.service';
import { lastValueFrom } from "rxjs";
import { DirectApiService } from "./directApi.service";


@Injectable({
    providedIn: 'root',
})

export class ItemsService {

    private _itemsView = signal<ItemFormat[]>([]);
    public itemsViewSignal = computed(() => this._itemsView());
    get itemsViewSignalValue(): ItemFormat[] {
        if(this._itemsView().length === 0){
            this.tryFetchItems();
        }
        return this._itemsView();
    }
    public SetItemsView(items: ItemFormat[]) {
        this._itemsView.set(items);
    }
    public ConcatItemsView(items: ItemFormat[]) {
        this._itemsView.set(this._itemsView().concat(items));
    }
    public ItemViewForNav(pageRef: string): ItemFormat[] {
        if(pageRef == ''){
            return this._itemsView();
        } else{
            return this._itemsView().filter(item => item.itemPageRef.toString() === pageRef);
        }
    }

    constructor(
        private readonly http: HttpClient,
        public directApiService: DirectApiService,
        public directSessionLogic: DirectSessionLogicService,
        
    ) { 
        this.tryFetchItems();
    }


    async initItems() {
        try{
            const response = await lastValueFrom( await this.directApiService.fetchItems() );
            this.ConcatItemsView( response as ItemFormat[] );
            console.log("items added to service"); //, this.itemList);
        }catch(e){
            console.error("Error fetching items: ", e);
            this.SetItemsView([]);
        }
    }

    async tryFetchItems(){

        if(this.itemsViewSignal.length === 0){
            console.log("no items in local storage, fetching from API");
            await this.initItems();
        }


        while(this.itemsViewSignal.length === 0){
            await new Promise(r => setTimeout(r, 100)); //wait 20ms and try again
        }
    }

    async getItemsByPageRef(pageRef: string): Promise<ItemFormat[]>{
        let items: ItemFormat[] = []; 
        items = items.concat(this.itemsViewSignal().filter(item => 
            item.itemPageRef.toString() == pageRef
            ));

        return items;
    }

    
    hasPropertyOfType(obj: any, property: string, type: string): boolean {
        if(obj.hasOwnProperty(property) 
            && typeof obj[property] === type){
            return true;
        }else{
            console.error("property: ", property, " is not of type: ", type);
            return false;
        }
    }
    
    // hasArrayOfType(obj: any, property: string, type: string): boolean {
    //     if(obj.hasOwnProperty(property) 
    //         && Array.isArray(obj[property]) 
    //         && obj[property].every((item: any) => typeof item === type)){
    //         return true;
    //     }else{
    //         console.error("property: ", property, " is not an array of type: ", type);
    //         return false;
    //     }
    //     // return obj.hasOwnProperty(property) && Array.isArray(obj[property]) && obj[property].every((item: any) => typeof item === type);
    // }
    
    // isItemFormat(item: any): item is ItemFormat {
    //     return typeof item === 'object' &&
    //         this.hasPropertyOfType(item, 'displayName', 'string') &&
    //         this.hasPropertyOfType(item, 'tagLine', 'string') &&
    //         this.hasArrayOfType(item, 'boldTagLineText', 'string') &&
    //         this.hasPropertyOfType(item, 'discription', 'string') &&
    //         this.hasArrayOfType(item, 'salesPoints', 'string') &&
    //         this.hasPropertyOfType(item, 'cartName', 'string') &&
    //         this.hasPropertyOfType(item, 'originalPrice', 'number') &&
    //         this.hasPropertyOfType(item, 'price', 'number') &&
    //         this.hasPropertyOfType(item, 'priceAsWholeNumber', 'boolean') &&
    //         this.hasPropertyOfType(item, 'itemFeatureRef', 'string') &&
    //         this.hasPropertyOfType(item, 'itemPageRef', 'string') &&
    //         this.hasPropertyOfType(item, 'isFixed', 'boolean') &&
    //         this.hasPropertyOfType(item, 'optionPosition', 'string') &&
    //         this.hasPropertyOfType(item, 'optionValue', 'string') &&
    //         this.hasPropertyOfType(item, 'imageUrl', 'string') &&
    //         this.hasPropertyOfType(item, 'addedToCart', 'boolean');
    // }

}